import { render, staticRenderFns } from "./CrewEventCard.vue?vue&type=template&id=74695840"
import script from "./CrewEventCard.vue?vue&type=script&lang=js"
export * from "./CrewEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports